import React from "react";
import "../About/Strength.css";

const Strength = () => {
  return (
    <section className="strength-section">
      <div className="strength-wrapper">
        {/* LEFT SIDE */}
        <div className="strength-left">
          <h2>Strength Through Partnership</h2>
          <h3>Journey Experts</h3>

          {/* MOVED TEXT */}
          <p className="strength-left-text">
            Click4Flight is proud to be a specialized division of the Journey
            Experts Group.
          </p>
        </div>

        {/* RIGHT SIDE */}
        <div className="strength-right">
          <p>
            By operating under the umbrella of Journey Experts, we combine the
            personalized, high-touch service of a boutique agency with the
            massive infrastructure and financial security of a major travel
            group.
          </p>

          <p>
            This partnership ensures that no matter where in the world you fly,
            you are backed by a team with decades of experience in global
            logistics and customer care.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Strength;